export const API = process.env.REACT_APP_BACKEND;
export const IMAGEAPI = process.env.REACT_APP_IMAGE;
export const DJANGO_CLIENT_ID = process.env.REACT_APP_DJANGO_CLIENT_ID;
export const DJANGO_SECRET_ID = process.env.REACT_APP_DJANGO_SECRET_ID;
export const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
export const LINKEDIN_SECRET_ID = process.env.REACT_APP_LINKEDIN_SECRET_ID;
export const LINKEDIN_AUTH_URL = process.env.REACT_APP_LINKEDIN_SECRET_ID;
export const LINKEDIN_SCOPE = process.env.REACT_APP_LINKEDIN_SCOPE;
export const LINKEDIN_REDIRECT_URL = process.env.REACT_APP_LINKEDIN_URL;